import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { useToast } from "../lib/toast";
import { Card } from "../components/ui/Card";
import { Button } from "../components/ui/Button";

interface Assignment {
  id: number;
  carrierName: string;
  plantName: string;
  role: string;
}

/** GSMFP — carrier assignments read from D1 (FR-017), replacing the
 * legacy's hardcoded FPCarAssgnToAdd recipient list. */
export function Freight() {
  const toast = useToast();
  const { data } = useQuery({ queryKey: ["freight"], queryFn: () => api.get<{ rows: Assignment[] }>("/freight/assignments").then((r) => r.rows) });

  return (
    <Card>
      <div className="p-4 font-semibold text-sm border-b border-slate-100 dark:border-white/10">Freight Partner Assignment</div>
      <table className="data w-full text-xs">
        <thead className="bg-slate-50 dark:bg-white/5 text-slate-500">
          <tr>
            <th className="p-3 text-left">Carrier</th>
            <th className="p-3 text-left">Plant</th>
            <th className="p-3 text-left">Role</th>
            <th className="p-3 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {(data ?? []).map((a) => (
            <tr key={a.id} className="border-t border-slate-100 dark:border-white/5">
              <td className="p-3">{a.carrierName}</td>
              <td className="p-3">{a.plantName}</td>
              <td className="p-3">{a.role}</td>
              <td className="p-3">
                <Button variant="ghost" onClick={() => toast("Manage carrier roles")}>
                  Manage
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
